import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LogService } from '../../shared/log/log.service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { TranslateService } from '@ngx-translate/core';
import { GroupPayConfigHttpService } from './grouppay-config.http.service';
import { Map } from 'immutable';
import { ConfigResponse } from '../models/config/config-response';
import { ConfigLookupType } from '../models/config/config-lookup-type';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Injectable()
export class GroupPayConfigStore {
  private defaultEndDateDelayDaysSubject = new ReplaySubject<ConfigResponse>(1);

  private allSubject = new BehaviorSubject(Map<ConfigLookupType, ConfigResponse>([]));

  constructor(private groupPayConfigHttpService: GroupPayConfigHttpService,
              private logService: LogService,
              private flashMessagesService: FlashMessagesService,
              private translateService: TranslateService) {
  }

  get defaultEndDateDelayDays(): Observable<ConfigResponse> {
    return this.defaultEndDateDelayDaysSubject.asObservable();
  }

  get defaultEndDateDelayDaysValue(): Observable<number> {
    return this.defaultEndDateDelayDays.map(configResponse => Number(configResponse.value));
  }

  private setDefaultEndDateDelayDays(configResponse: ConfigResponse) {
    this.defaultEndDateDelayDaysSubject.next(configResponse);
  }

  get allConfigurations(): Observable<Map<ConfigLookupType, ConfigResponse>> {
    return this.allSubject.asObservable();
  }

  loadConfig(key: ConfigLookupType, chain: string, brand: string, propertyId: string, agencyId: string):
      Observable<ConfigResponse> {
    const response = this.groupPayConfigHttpService.getGroupPayConfigByValues(key, chain, brand, propertyId, agencyId)
      .catch(error => {
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_SINGLE', {
          configValue: key.toString()
        }));
        this.logService.error(`Error retrieving configuration value (${key.toString()}): ${error}`);
        return Observable.throw(error);
      })
      .map(configResponse => {
        this.updateOneConfig(key, configResponse);
        return configResponse;
      });
    return response;
  }

  loadAllConfig(chain: string, brand: string, propertyId: string, agencyId: string): Observable<Map<ConfigLookupType, ConfigResponse>> {
    const response = this.groupPayConfigHttpService.getAllGroupPayConfigByValues(chain, brand, propertyId, agencyId)
      .catch(error => {
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_ALL'));
        this.logService.error(`Error retrieveing all configuration values: ${error}`);
        return Observable.throw(error);
      })
      .map((responseMap: Map<ConfigLookupType, ConfigResponse>) => {
        this.updateAllConfig(responseMap);
        return responseMap;
      });
    return response;
  }

  private updateOneConfig(key: ConfigLookupType, configResponse: ConfigResponse) {
    const map = this.allSubject.getValue();
    this.allSubject.next(map.set(key, configResponse));

    if (key === ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS) {
        this.setDefaultEndDateDelayDays(configResponse);
    }
  }

  private updateAllConfig(configMap: Map<ConfigLookupType, ConfigResponse>) {
    this.allSubject.next(configMap);

    if (configMap.has(ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS)) {
      this.setDefaultEndDateDelayDays(configMap.get(ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS));
    }
    if (configMap.has(ConfigLookupType.AUTO_PAY)) {
      // TODO add this later
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/grouppay-config.store.ts